import { render } from "./AiChipsBlock.vue?vue&type=template&id=5c724990&scoped=true"
import script from "./AiChipsBlock.vue?vue&type=script&lang=js"
export * from "./AiChipsBlock.vue?vue&type=script&lang=js"

import "./AiChipsBlock.vue?vue&type=style&index=0&id=5c724990&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c724990"]])

export default __exports__